module.exports = __webpack_public_path__ + "img/arrow_down_active.81ab52fb.png";